import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { openModalDialog } from "../../../../../actions/layoutActions";
import {
  initDataComponent,
  performRetrieveListRequest,
} from "../../../../../actions/dataComponentActions";
import propTypes from "../../../../../constants/propTypes";

import BrandsTable from "./BrandsTable";
import { getDataComponentFlattenedRequestState } from "../../../../../reducers/dataComponentReducer";
import withRenderOnPermissionActive from "../../../../hocs/withRenderOnPermissionActive";

export const dataComponentId = "brandsGrid";
export const BrandsTableContainer = ({ openModalDialog, dataComponent }) => {
  const handleOpenCreateModal = useCallback(() => {
    openModalDialog("Create Brand", "CreateBrand", {}, false);
  }, [openModalDialog]);

  const handleOpenEditModal = useCallback(
    brand => {
      openModalDialog(
        `Edit ${brand.name}`,
        "EditBrand",
        {
          brand,
        },
        false
      );
    },
    [openModalDialog]
  );

  const handleOpenDeleteModal = useCallback(
    ({ id, name }) => {
      openModalDialog(
        `Delete ${name}`,
        "DeleteBrand",
        {
          brandId: id,
          title: name,
        },
        false
      );
    },
    [openModalDialog]
  );

  return (
    <BrandsTable
      onOpenCreateModal={handleOpenCreateModal}
      onOpenEditModal={handleOpenEditModal}
      onOpenDeleteModal={handleOpenDeleteModal}
      dataComponent={dataComponent}
    />
  );
};

BrandsTableContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  openModalDialog: PropTypes.func.isRequired,
  initDataComponent: PropTypes.func,
  performRetrieveListRequest: PropTypes.func,
};

export const mapStateToProps = state => ({
  dataComponent: getDataComponentFlattenedRequestState(dataComponentId, state),
});

export const mapDispatchToProps = {
  push,
  openModalDialog,
  performRetrieveListRequest,
  initDataComponent,
};

export default withRenderOnPermissionActive(
  connect(mapStateToProps, mapDispatchToProps)(BrandsTableContainer),
  ["general-settings-brands"]
);
